import { Instance, types } from "mobx-state-tree";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { MessageTag } from "@fidget/common/models/messageTag";
import { getFriendlyDateString, getTimeString } from "@fidget/common/utils/timeFormatter";
import { AnyUserReferenceType } from "../../../users/AnyUserReferenceType";
import { ChatItemType } from "../ChatItemType";
import { BaseChatItem } from "./BaseChatItem";
/**
 *  Notification about events related to meetings.
 *  Its text content will update with users (eg. after fetching the profiles).
 *  TODO: `subtype` should have its own type
 */
export const MeetingEventChatItem = types
  .compose(
    "MeetingEventChatItem",
    BaseChatItem,
    types.model({
      type: types.literal(ChatItemType.MeetingEvent),
      subtype: types.frozen(
        types.enumeration<MessageTag>("MeetingEventSubtype", Object.values(MessageTag))
      ),
      agent: AnyUserReferenceType,
      meetingTimestamp: types.number
    })
  )
  .views((self) => ({
    get text() {
      const name = self.agent.displayedName;
      const date = getFriendlyDateString(self.meetingTimestamp, {
        useToday: true,
        useTomorrow: true
      });
      const time = getTimeString(self.meetingTimestamp);

      if (self.subtype === MessageTag.MEETING_RESCHEDULED) {
        return intl.formatMessage("conversation.event.meetingRescheduled", { name, date, time });
      } else if (self.subtype === MessageTag.MEETING_CANCELLED) {
        return intl.formatMessage("conversation.event.meetingCancelled", { name });
      }
      // TODO: handle unknown subtype
      return "";
    }
  }));

export interface IMeetingEventChatItem extends Instance<typeof MeetingEventChatItem> {}
